import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  spreadSheetTitle: {
    marginTop: 24
  },
  spreadSheet: {
    marginTop: 24
  },
  spreadSheetTable: {
    '& .Spreadsheet__cell, & .Spreadsheet__header': {
      '&:nth-child(2)': {
        width: '30%'
      },
      '&:nth-child(3)': {
        width: '100%'
      }
    }
  }
})

export default useStyles
